module.exports = __webpack_public_path__ + "img/logo.baeaf23f.png";